import React, { Component } from 'react';
import { Modal, Button, Dimmer, Loader, Table, Checkbox, Icon } from 'semantic-ui-react';
import { notEnrolledDebtURL } from "../../shared/urls/clientapi";
import { enrollDebtURL } from "../../shared/urls/clientapi";
import { callService, GET, POST } from "../../shared/serviceInvoker";
import FormatCurrency from "../FormatCurrency"
import ContactUs from "../../shared/components/ContactUs";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class AddDebtModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showLoader: true,
            formValid: false,
            success: false
        }
    }
    state = { modalOpen: false, confirmOpen: false }

    componentDidMount() {
        var contact_id = "";
        if (sessionStorage.getItem("contact_id")) {
            contact_id = sessionStorage.getItem("contact_id");
        }

        callService(
            GET,
            notEnrolledDebtURL.replace('{contact_id}', contact_id),
            null,
            response => {
                var result = response.data.data;
                this.setState({ data: result, showLoader: false });
            },
            error => {
                var result = [];
                this.setState({ data: result, showLoader: false });
            }
        );
    }

    handleSubmit = (event) => {
        let selected_debt_ids = [];
        let table = document.getElementById("not_enrolled_debts");
        for (let i = 0; i < table.rows.length - 1; i++) {
            let chk = document.getElementById("chk-" + i);
            if (chk.checked) {
                selected_debt_ids.push(chk.value.replace("ne_", ""));
            }

        }
        event.preventDefault();
        let contact_id = "";
        if (sessionStorage.getItem("contact_id")) {
            contact_id = sessionStorage.getItem("contact_id");
        }
        let bodyFormData = new FormData();
        bodyFormData.append('debt_ids', selected_debt_ids);
        callService(
            POST,
            enrollDebtURL.replace('{contact_id}', contact_id),
            bodyFormData,
            response => {

                this.setState({ success: true, confirmOpen: true });

                ReactGA.set({ userId: contact_id });
                ReactGA.ga('set', 'dimension1', contact_id);
                ReactGA.event({
                    category: 'Debts',
                    action: 'User Enrolled Debt',
                });
                trackEvent('Debts', 'User Enrolled Debt');
            },
            error => {
                this.setState({ success: false });
            }
        );


    };

    handleCheckbox = (e) => {
        let valid = false
        let table = document.getElementById("not_enrolled_debts");
        for (let i = 0; i < table.rows.length - 1; i++) {
            let chk = document.getElementById("chk-" + i);
            if (chk.checked) {
                valid = true
            }
        }
        let isImpersonating = sessionStorage.getItem("isImpersonating");
        if (isImpersonating !== 'true') {
            this.setState({ formValid: valid });
        }
    }

    handleClose = () => this.setState({ modalOpen: false, formValid: false, confirmOpen: false })
    handleOpen = () => this.setState({ modalOpen: true, formValid: false, confirmOpen: false })

    render() {
        const { showLoader } = this.state;
        const PageLoader = () => (
            <Dimmer active={showLoader} inverted>
                <Loader size='medium'>Loading Not Enrolled Debts ...</Loader>
            </Dimmer>
        )

        var not_enrolled = this.state.data.map((account_grouping, index) =>
            <div key={index}>
                <PageLoader />
                <p />

                <Table id='not_enrolled_debts'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Creditor - Last 4 of acct</Table.HeaderCell>
                            <Table.HeaderCell>Balance</Table.HeaderCell>
                            <Table.HeaderCell>Enroll</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>

                        {account_grouping.accounts.map((account, row_index) => {
                            return (
                                <Table.Row key={row_index}>
                                    <Table.Cell>
                                        {account.debt_name}
                                        {account.debt_account_last_four &&
                                            <span> - {account.debt_account_last_four}</span>
                                        }
                                    </Table.Cell>
                                    <Table.Cell>
                                        <FormatCurrency amount={account.debt_amount} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Checkbox
                                            id={'chk-' + row_index}
                                            disabled={account.disable_checkbox}
                                            value={account.debt_id}
                                            onClick={this.handleCheckbox}
                                        />
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })}

                    </Table.Body>
                    <Table.Footer>
                    </Table.Footer>
                </Table>
                <p />
            </div>
        );

        return (
            <Modal
                trigger={<a onClick={this.handleOpen} >+ Enroll a new account</a>}
                open={this.state.modalOpen}
                onClose={this.handleClose}
                closeIcon
            >
                <Modal.Header>Enroll Debts</Modal.Header>
                <Modal.Content>

                    {
                        this.state.confirmOpen ?
                            <div>
                                <p>The debts have been marked for enrollment. You will be contacted by support if anything further is needed to enroll the debts.</p>
                            </div>
                            :
                            <div>
                                <p>Here you can add debts to your program. Remember, the more debts you have as part of the program, the better the program works and the more money you'll save in the long run.</p>
                                {not_enrolled}
                                <p>Select the debts you'd like to add to the program and click Enroll Debts. If a debt is not able to be selected, either that debt is already pending enrollment or does not meet the criteria to be enrolled in the program.</p>
                                <p>Be aware that adding debts to the program may require an addition to your monthly deposit, but you will be contacted before any change is made.</p>
                                <p>If any information about the debts has changed (such as the balance), or you have a debt not listed above that you'd like to be part of the program, <ContactUs />  and we will do our best to assist you.</p>
                            </div>
                    }
                </Modal.Content>
                <Modal.Actions>
                    {
                        this.state.confirmOpen ?
                            <div className="divActionButtonRight">
                                <Button color='green' onClick={this.handleClose}>
                                    <Icon name='checkmark' /> Got it
                                </Button>
                            </div>
                            :
                            <div className="divActionButtonLeft">
                                <Button negative onClick={this.handleClose}>Cancel Changes</Button>
                                <span className="divRight">
                                    <Button primary onClick={this.handleSubmit} disabled={!this.state.formValid} >Enroll Debts</Button>
                                </span>
                            </div>
                    }
                </Modal.Actions>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AddDebtModal/index.js